import { Size } from '@ff-os/shared-utils/types/Size';
import exifr from 'exifr';
import { loadDOMImage } from 'ff-canvas';
import { createCanvas } from './createCanvas';
import { doesBrowserAutoOrientImages } from './doesBrowserAutoOrientImages';
import { orientSize, resizeAndOrientImage } from './image-orientation';
import { mapExifOrientationToNumber } from './mapExifOrientationToNumber';
import { toBlob } from './toBlob';

export const normalizeImage = async (
    image: File
) => {

    const url = URL.createObjectURL(image);
    const size = await loadSizeFromImage(url);
    const newSize = resizeToTargetSize(size, 500);

    if (await doesBrowserAutoOrientImages()) {
        return {
            url: await resizeImage(url, newSize),
            width: size.width,
            height: size.height
        };
    } else {

        const exif = await exifr.parse(image, true);
        const orientation = mapExifOrientationToNumber(exif['Orientation']) || 1;
        const orientedSize = orientSize(size, orientation);

        return {
            url: await resizeAndOrientImage(url, orientation, newSize),
            width: orientedSize.width,
            height: orientedSize.height
        };
    }
};

const loadSizeFromImage = async (imageUrl: string) => {
    const element = await loadDOMImage(imageUrl, 'anonymous');
    return {
        width: element.width,
        height: element.height
    };
};

const resizeToTargetSize = (
    size: Size,
    targetSize: number
) => {

    const width = size.width > size.height
        ? targetSize * (size.width / size.height)
        : targetSize;

    const height = size.width < size.height
        ? targetSize * (size.height / size.width)
        : targetSize;

    return {
        width,
        height
    };
};

const resizeImage = async (imageUrl: string, size: Size) => {

    const canvas = createCanvas(size.width, size.height);
    const ctx = canvas.getContext('2d')!;

    const image = await loadDOMImage(imageUrl, 'anonymous');

    ctx.clearRect(0, 0, size.width, size.height);
    ctx.drawImage(image, 0, 0, size.width, size.height);

    URL.revokeObjectURL(imageUrl);

    return URL.createObjectURL(await toBlob(canvas));
};